var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{style:({
    position: 'absolute',
    top: _vm.top,
    right: _vm.right,
    height: 'fit-content',
  }),attrs:{"position":"is-top","multilined":"","active":_vm.tooltip.length > 0,"content-class":"custom-tooltip"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('p',{staticStyle:{"width":"33rem","text-wrap":"wrap","padding":"15px"},domProps:{"innerHTML":_vm._s(_vm.tooltip)}})]},proxy:true}])},[_c('b-tag',{staticClass:"px-1",staticStyle:{"height":"12px"},attrs:{"type":"is-info"}},[_c('p',{staticStyle:{"font-size":"10px"}},[_vm._v("BETA")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }